import { useState } from "react";

import { AppIcon } from "../Common/AppIcon";
import { NavLink } from "./NavLink";

import '../../styles/NavBar.css';

export function NavBar({ navbar }) {

  const [isActive, setIsActive] = useState(false);

  const changeIsActive = ()=>{
    setIsActive(!isActive);
  };

  const resetIsActive = ()=>{
    setIsActive(false);
  };

  const scrollToSection = (sectionId) =>{
    const section = document.getElementById(sectionId);

    if(section){
      section.scrollIntoView({behavior:'smooth'});
    }
  };

  const logobw = `img/${navbar.img}`;

  return(
    <div>
      <nav className="navbar is-fixed-top nav-container">
        <div className="navbar-brand">
          <div className=""
            style={{cursor:"pointer"}}
            onClick={()=>{scrollToSection('intro'); resetIsActive()}}
          >
            <img src={logobw} style={{width:"40px", height:"40px", margin:"10px"}} />
          </div>

          <button role="button"
            className="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasic"
            onClick={changeIsActive}
          >
            <AppIcon iconName={'Hamburger'}/>
          </button>
          
        </div>

        <div id="navbarBasic" className={`navbar-menu p-0 is-active ${isActive ? 'show-menu': 'hide-menu'}`}>

          <div className="navbar-start n-start">
            {navbar.links.map((link)=>(
              link.service == 'Contáctanos' ? null: (
                <div key={link.service} onClick={()=>{scrollToSection(link.url); changeIsActive()}}>
                  <NavLink link={link}/>
                </div>
              )
            ))}

          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <div className="field is-grouped">

                <a
                  key={navbar.links[navbar.links.length - 1].service}
                  className="button is-success is-fullwidth"
                  onClick={()=>{scrollToSection(navbar.links[navbar.links.length - 1].url); changeIsActive()}}
                  >
                    
                  <AppIcon iconName={navbar.links[navbar.links.length - 1].service} />
                  &nbsp;{navbar.links[navbar.links.length - 1].service}
                </a>

              </div>
            </div>
          </div>

        </div>

      </nav>
    </div>
  );
}